<template>
  <a-drawer
    width="55%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('课程标题')" prop="title">
        <a-input v-model="form.title" :maxLength="64" :placeholder="$t('请输入')+$t('课程标题')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('课程分类')" prop="categoryId">
        <a-row :gutter="8">
          <a-col :span="12">
            <a-select v-model="form.categoryFirstId" :placeholder="$t('请选择')+$t('一级分类')" @change="onFirstChange" allow-clear>
              <a-select-option v-for="item in categoryTree" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="12">
            <a-select v-model="form.categoryId" :placeholder="$t('请选择')+$t('二级分类')" allow-clear>
              <a-select-option v-for="item in secondOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-form-model-item>
      <a-form-model-item :label="$t('课程封面')" prop="coverPic">
        <oss-upload-single :height="100" :width="100" v-model="form.coverPic" prefix="edu" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('课程简介')" prop="summary">
        <a-input v-model="form.summary" :maxLength="500" :placeholder="$t('请输入')+$t('课程简介')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('是否收费')" prop="isCharge">
        <a-switch v-model="form.isCharge" />
      </a-form-model-item>
      <a-form-model-item :label="$t('课程价格')" prop="price" v-if="form.isCharge">
        <a-input-number v-model="form.price" :min="0" :precision="2" style="width: 100%" :placeholder="$t('请输入')+$t('课程价格')" />
      </a-form-model-item>
      <a-divider orientation="left">{{ $t('课时列表') }}</a-divider>
      <div v-for="(lesson, index) in form.lessons" :key="index" class="lesson-item">
        <a-row :gutter="8" style="margin-bottom: 8px">
          <a-col :span="7">
            <a-input v-model="lesson.title" :maxLength="64" :placeholder="$t('课时标题')" />
          </a-col>
          <a-col :span="9">
            <oss-upload-single :height="60" :width="60" v-model="lesson.videoUrl" prefix="edu" type="video"/>
          </a-col>
          <a-col :span="3">
            <a-input-number v-model="lesson.duration" :min="0" :placeholder="$t('时长(秒)')" style="width: 100%" />
          </a-col>
          <!--<a-col :span="3">
            <a-tooltip :title="$t('可试看')">
              <a-switch v-model="lesson.isTrial" size="small" />
            </a-tooltip>
          </a-col>-->
          <a-col :span="2" v-if="form.lessons.length > 1">
            <a @click="removeLesson(index)"><a-icon type="delete" style="color:#f5222d" /></a>
          </a-col>
        </a-row>
      </div>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :maxLength="200" :placeholder="$t('请输入')+$t('备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEduCourse, addEduCourse, updateEduCourse } from '@/api/edu/course'
import { mapGetters } from 'vuex'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      submitLoading: false,
      formTitle: '',
      categoryTree: [],
      form: this.initForm(),
      formType: 1,
      open: false,
      rules: {
        title: [{ required: true, message: '课程标题不能为空', trigger: 'blur' }],
        categoryId: [{ required: true, message: '请选择课程分类', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict']),
    secondOptions () {
      const first = this.categoryTree.find(item => item.id === this.form.categoryFirstId)
      return first && first.children ? first.children : []
    }
  },
  methods: {
    initForm() {
      return {
        id: null,
        title: null,
        coverPic: null,
        summary: null,
        categoryFirstId: undefined,
        categoryId: undefined,
        isCharge: false,
        price: 0,
        remark: null,
        lessons: [this.initLesson()]
      }
    },
    initLesson () {
      return {
        id: null,
        title: null,
        videoUrl: null,
        duration: 0,
        sort: 0,
        isTrial: false
      }
    },
    onFirstChange () {
      this.form.categoryId = undefined
    },
    removeLesson (index) {
      this.form.lessons.splice(index, 1)
    },
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = this.initForm()
    },
    /** 新增按钮操作 */
    handleAdd(categoryTree) {
      this.reset()
      this.categoryTree = categoryTree || []
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, categoryTree) {
      this.reset()
      this.categoryTree = categoryTree || []
      this.formType = 2
      getEduCourse({ id: row.id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          title: data.title,
          coverPic: data.coverPic,
          summary: data.summary,
          categoryFirstId: data.categoryFirstId,
          categoryId: data.categoryId,
          isCharge: data.isCharge,
          price: data.price,
          remark: data.remark,
          lessons: data.lessons && data.lessons.length ? data.lessons : [this.initLesson()]
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.isCharge && (this.form.price === null || this.form.price <= 0)) {
            this.$message.warning(this.$t('收费课程价格必须大于0'), 3)
            return false
          }
          // 空白课时不提交
          this.form.lessons = this.form.lessons.filter(l => l.title || l.videoUrl)
          this.form.lessons.forEach((l, i) => { l.sort = i })
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEduCourse(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEduCourse(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.lesson-item {
  padding: 8px;
  background: #fafafa;
  border-radius: 4px;
  margin-bottom: 8px;
}
</style>
